module.exports = __webpack_public_path__ + "img/statues.48d052a4.png";